import {defineStore} from "pinia";
import {computed, type ComputedRef, type Ref, ref} from "vue";
import type {EocSummaries, EocSummariesItem} from "@/api/endpoints/statisticsWeb.ts";
import {custom_moment} from '@/plugins/moment-cultured';

export const useAiSummariesStore = defineStore('aiSummaries', () => {
  const pageCount: Ref<number> = ref(0),
    summaries: Ref<EocSummariesItem[]> = ref([]);
  
  const hasSummaries: ComputedRef<boolean> = computed(() => summaries.value.length > 0);
  
  const clear = () => {
    pageCount.value = 0;
    summaries.value = [];
  }
  
  const setAiSummariesStore = (resp: EocSummaries) => {
    setPageCount(resp.pageCount);
    setSummaries(resp.summaries);
  }
  
  const setPageCount = (ct: number) => {
    pageCount.value = ct;
  }
  
  const setSummaries = (sums: EocSummariesItem[]) => {
    summaries.value = sums.length
      ? [...sums].sort((a, b) => custom_moment(b.deliveryDate).diff(custom_moment(a.deliveryDate)))
      : [];
  }
  
  return {
    summaries,
    hasSummaries,
    clear,
    setAiSummariesStore,
    setPageCount,
    setSummaries
  }
});